import apiUtils from '../util/ApiUtils';

const appid = 'dc7536ec2b15c6cebf558fa78a8c25fe';
const baseUrl = 'https://api.openweathermap.org/data/2.5';

export default class WeatherApi {

    static findCityId(query) {
        const queryString = apiUtils.buildQueryString({
            appid,
            q: query,
            type: 'like'
        });
        return fetch(`${baseUrl}/find${queryString}`)
            .then(result => result.json());
    }

    static getWeatherByCityId(id, units='metric') {
        const queryString = apiUtils.buildQueryString({
            appid,
            id,
            units
        });
        return fetch(`${baseUrl}/weather${queryString}`)
            .then(result => result.json());
    }

}


// WEBPACK FOOTER //
// ./src/api/weatherApi.js